function setCookie(name, value, hours) {
var expires = "";
if (hours) {
    var date = new Date();
    //date.setTime(date.getTime() + (days*24*60*60*1000));
    date.setTime(date.getTime() + (hours * 60 * 60 * 1000));
    expires = "; expires=" + date.toUTCString();
}
document.cookie = name + "=" + (value || "") + expires + "; path=/";
}
function getCookie(name) {
var nameEQ = name + "=";
var ca = document.cookie.split(';');
for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
}
return null;
}
window.addEventListener('load', (event) => {
    if (getCookie('announcementBarFlag') == 'hide') {
        document.querySelector(".announcement-bar").style.marginTop = 0 ;
    }
}); 
$(".announcement-bar span.close").on('click', function () {
    setCookie("announcementBarFlag", "hide", 365);
    $(this).parents('.announcement-bar').slideUp();
    var winWidth = $(window).width();
    if (winWidth > 768) {
        var headerMainHeight = $('div.header-main').innerHeight(),
            navigationHeight = $('div.desktop-navigation').innerHeight();
        $('body').css('padding-top', headerMainHeight + navigationHeight);
    }
});